import React from 'react';
import { ManualDataRefetchCountHandle } from '../../../types';
import { ChartDataFetchError } from '../../errors/components/ChartDataFetchError';

export interface ErrorData {
  error: Error;
  componentStack: string;
  eventId: string;
  resetError(): void;
}

interface DataVizContainerChartDataFetchErrorProps {
  manualDataRefetchCountHandle: ManualDataRefetchCountHandle;
  errorData?: ErrorData;
}

export const DataVizContainerChartDataFetchError = (
  props: DataVizContainerChartDataFetchErrorProps
) => {
  const { manualDataRefetchCountHandle, errorData } = props;
  return (
    <ChartDataFetchError
      errorData={errorData}
      retry={() => {
        manualDataRefetchCountHandle.increment();
      }}
    />
  );
};
